import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Typography from '../../atoms/typography';
import RedWarningSvg from '../../public/images/RedWarning.svg';

const FinalSaleWrapper = styled.div`
    display: flex;
`;

const WarningIcon = styled(RedWarningSvg)`
  height: 16px;
  width: 16px;
  margin-right: 0.6rem;
`;

const FinalSaleText = styled(Typography)`
  color: ${(props) => props.theme.color.redError};
  line-height: 1.8rem;
  font-weight: 400;
  }
`;

const FinalSaleWarning = (props) => (
  <FinalSaleWrapper className={props.className}>
    <WarningIcon />
    <FinalSaleText element="span" like="dec-1">
      This item is final sale and not returnable.
    </FinalSaleText>
  </FinalSaleWrapper>
);

FinalSaleWarning.defaultProps = {
  className: ''
};

FinalSaleWarning.propTypes = {
  className: PropTypes.string
};

export default FinalSaleWarning;
